import receivingInformation from './app.vue'

function install(Vue) {
  function dialog(options = {}) {
    return new Promise((resolve, reject) => {
      const constructor = Vue.extend(receivingInformation)
      const JoinCalssDia = new constructor({
        el: document.createElement('div')
      })
      for (let key in options) {
        JoinCalssDia[key] = options[key]
      }
      JoinCalssDia.resolve = resolve
      JoinCalssDia.reject = reject
      document.body.appendChild(JoinCalssDia.$el)
    })
  }
  Vue.prototype.$receivingInformation = dialog
}
export default {
  install
}



// WEBPACK FOOTER //
// ./src/components/Stu/receivingInformation/index.js